import React, { Fragment, useCallback, useEffect } from 'react';
import 'antd/dist/antd.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Icon, Input, Tooltip } from 'antd';
import Guest from '../../classes/Guest';
import { CONTACT_TYPE_MAIL, CONTACT_TYPE_PHONE } from '../../defaults/ContactTypes';
import SwitchContactType from '../SwitchContactType';
import { 
  addNewGuest,
  changeGuestData,
  removeGuest,
  setGuestMailError,
  setGuestMobileError,
  setGuestNameError,
  setGuestContactType
} from '../../ducks/GuestsDucks';
import { FormStyled } from './styles';

const FormGuestData = ({ index, isTheFirstForm, isTheLatestForm, form }) => {
  const guests = useSelector(({ guests }) => guests);

  const dispatch = useDispatch();

  const callAddNewGuest = useCallback(
    guest => dispatch(addNewGuest(guest)),
    [dispatch, guests]
  );

  const callChangeGuestData = useCallback(
    guest => dispatch(changeGuestData(guest)),
    [dispatch, guests]
  );

  const callRemoveGuest = useCallback(
    guestIndex => dispatch(removeGuest(guestIndex)),
    [dispatch, guests]
  );

  const callSetGuestMailError = useCallback(
    (guestIndex, error) => dispatch(setGuestMailError(guestIndex, error)),
    [dispatch, guests]
  );

  const callSetGuestMobileError = useCallback(
    (guestIndex, error) => dispatch(setGuestMobileError(guestIndex, error)),
    [dispatch, guests]
  );

  const callSetGuestNameError = useCallback(
    (guestIndex, error) => dispatch(setGuestNameError(guestIndex, error)),
    [dispatch, guests]
  );

  const callSetGuestContactType = useCallback(
    (guestIndex, contactType) => dispatch(setGuestContactType(guestIndex, contactType)),
    [dispatch, guests]
  );

  const documentSignatureSelected = useSelector(({ documents, application }) =>
    documents.data.length &&
    documents.data.find(document => document.selected && document.hasSignature) || application.hasSignature)

  const { getFieldDecorator } = form;

  const guest = guests[index];

  const { mail: mailErrors } = form.getFieldsError(['mail']);

  const handleChange = () => {

    if (!documentSignatureSelected) {

      form.validateFields((err, values) => {
        if (err) {
          return;
        }

        const { name, mail, mobile } = values;

        let hasError = false;

        if (!name || !name.length) {
          hasError = true;
          callSetGuestNameError(index, 'O nome é obrigatório.');
        }
        else {
          callSetGuestNameError(index, false);
        }

        if (guest.contactType === CONTACT_TYPE_MAIL) {

          if (!mail || !mail.length) {
            hasError = true;
            callSetGuestMailError(index, 'O E-mail é obrigatório.');
          }
          else {
            callSetGuestMailError(index, false);
          }
        }
        else {

          if (!mobile || !mobile.length) {
            hasError = true;
            callSetGuestMobileError(index, 'O celular é obrigatório.');
          }
          else {
            callSetGuestMobileError(index, false);
          }

        }

        if (!hasError) {
          let newGuest;

          try {
            newGuest = new Guest(index, name, mail, mobile);
            callChangeGuestData(newGuest);
          }
          catch (e) {
            callSetGuestMobileError(index, 'Celular inválido');
          }
        }
      });
    } else {
      form.validateFields((err, values) => {
        if (err) {
          return;
        }

        const { name, mail, mobile } = values;

        let hasError = false;

        if (!name || !name.length) {
          hasError = true;
          callSetGuestNameError(index, 'O nome é obrigatório.');
        }
        else {
          callSetGuestNameError(index, false);
        }


        if (!mail || !mail.length) {
          hasError = true;
          callSetGuestMailError(index, 'O E-mail é obrigatório.');
        }
        else {
          callSetGuestMailError(index, false);
        }

        if (!mobile || !mobile.length) {
          hasError = true;
          callSetGuestMobileError(index, 'O celular é obrigatório.');
        }
        else {
          callSetGuestMobileError(index, false);
        }

        if (!hasError) {
          let newGuest;

          try {
            newGuest = new Guest(index, name, mail, mobile);
            callChangeGuestData(newGuest);
          }
          catch (e) {
            callSetGuestMobileError(index, 'Celular inválido');
          }
        }
      });
    }

  }

  const changeContactType = type => {
    callSetGuestContactType(index, type);
  }

  useEffect(() => {
    if (guest.guest) {
      handleChange()
    }
  }, [documentSignatureSelected])

  return (
    <FormStyled 
      layout="inline"
      onChange={handleChange}
    >
      <Form.Item
        label="Nome"
        hasFeedback={true}
        validateStatus={
          guest
            ? (
              guest.errors.name !== null
                ? (guest.errors.name ? 'error' : 'success')
                : null
            )
            : null
        }>
        {getFieldDecorator('name')(
          <Input
            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="Nome"
          />,
        )}
      </Form.Item>
      {
        !documentSignatureSelected &&
        <SwitchContactType
          contactType={guest.contactType}
          onChange={contactType => changeContactType(contactType)} />
      }
      {
        documentSignatureSelected ? (
          <Fragment>
            <Form.Item
              label="Celular"
              hasFeedback={true}
              help={null}
              validateStatus={
                guest
                  ? (
                    guest.errors.mobile !== null
                      ? (guest.errors.mobile ? 'error' : 'success')
                      : null
                  )
                  : null
              }>
              {getFieldDecorator('mobile')(
                <Input
                  prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="number"
                  placeholder="(99)99999-9999"
                />,
              )}
            </Form.Item>
            <Form.Item
              label="E-mail"
              hasFeedback={true}
              help={null}
              validateStatus={
                mailErrors
                  ? 'error'
                  : (
                    guest
                      ? (
                        guest.errors.mail !== null
                          ? (guest.errors.mail ? 'error' : 'success')
                          : null
                      )
                      : null
                  )
              }>
              {getFieldDecorator('mail', {
                rules: [{ type: 'email' }]
              })(
                <Input
                  prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="string"
                  placeholder="email@email.com" />,
              )}
            </Form.Item>
          </Fragment>
        ) :
          guest.contactType === CONTACT_TYPE_PHONE
            ? <Form.Item
              label="Celular"
              hasFeedback={true}
              help={null}
              validateStatus={
                guest
                  ? (
                    guest.errors.mobile !== null
                      ? (guest.errors.mobile ? 'error' : 'success')
                      : null
                  )
                  : null
              }>
              {getFieldDecorator('mobile')(
                <Input
                  prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="number"
                  placeholder="(99)99999-9999"
                />,
              )}
            </Form.Item>
            : <Form.Item
              label="E-mail"
              hasFeedback={true}
              help={null}
              validateStatus={
                mailErrors
                  ? 'error'
                  : (
                    guest
                      ? (
                        guest.errors.mail !== null
                          ? (guest.errors.mail ? 'error' : 'success')
                          : null
                      )
                      : null
                  )
              }>
              {getFieldDecorator('mail', {
                rules: [{ type: 'email' }]
              })(
                <Input
                  prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="string"
                  placeholder="email@email.com" />,
              )}
            </Form.Item>
      }

      {
        isTheLatestForm && (
          <Fragment>
            {
              !isTheFirstForm &&
              <Form.Item>
                <Tooltip placement="top" title="Remover convidado">
                  <Button
                    icon="minus"
                    onClick={() => callRemoveGuest(index)}
                    shape="circle" />
                </Tooltip>
              </Form.Item>
            }
            <Form.Item>
              <Tooltip placement="top" title="Adicionar novo convidado">
                <Button icon="plus" onClick={callAddNewGuest} shape="circle" />
              </Tooltip>
            </Form.Item>
          </Fragment>
        )
      }
    </FormStyled>
  )
}

FormGuestData.propTypes = {
  index: PropTypes.number.isRequired,
  isTheFirstForm: PropTypes.bool.isRequired,
  isTheLatestForm: PropTypes.bool.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }).isRequired
}

export default Form.create()(FormGuestData);



// WEBPACK FOOTER //
// ./src/components/FormGuestData/index.js